var map = {
	"./Base": [
		2050,
		0,
		49
	],
	"./Base/": [
		2050,
		0,
		49
	],
	"./Base/index": [
		2050,
		0,
		49
	],
	"./Base/index.js": [
		2050,
		0,
		49
	],
	"./Base/style": [
		2828,
		21
	],
	"./Base/style.js": [
		2828,
		21
	],
	"./Clutch": [
		2142,
		0,
		21,
		49,
		266,
		454
	],
	"./Clutch/": [
		2142,
		0,
		21,
		49,
		266,
		454
	],
	"./Clutch/index": [
		2142,
		0,
		21,
		49,
		266,
		454
	],
	"./Clutch/index.js": [
		2142,
		0,
		21,
		49,
		266,
		454
	],
	"./Clutch/style": [
		2904,
		21,
		266
	],
	"./Clutch/style.js": [
		2904,
		21,
		266
	],
	"./NewUi": [
		2143,
		0,
		21,
		49,
		267,
		455
	],
	"./NewUi/": [
		2143,
		0,
		21,
		49,
		267,
		455
	],
	"./NewUi/index": [
		2143,
		0,
		21,
		49,
		267,
		455
	],
	"./NewUi/index.js": [
		2143,
		0,
		21,
		49,
		267,
		455
	],
	"./NewUi/style": [
		2905,
		21,
		267
	],
	"./NewUi/style.js": [
		2905,
		21,
		267
	],
	"./OldUi": [
		2144,
		0,
		21,
		49,
		268,
		456
	],
	"./OldUi/": [
		2144,
		0,
		21,
		49,
		268,
		456
	],
	"./OldUi/index": [
		2144,
		0,
		21,
		49,
		268,
		456
	],
	"./OldUi/index.js": [
		2144,
		0,
		21,
		49,
		268,
		456
	],
	"./OldUi/style": [
		2906,
		21,
		268
	],
	"./OldUi/style.js": [
		2906,
		21,
		268
	],
	"./SpireonNew": [
		2145,
		0,
		21,
		49,
		269,
		457
	],
	"./SpireonNew/": [
		2145,
		0,
		21,
		49,
		269,
		457
	],
	"./SpireonNew/index": [
		2145,
		0,
		21,
		49,
		269,
		457
	],
	"./SpireonNew/index.js": [
		2145,
		0,
		21,
		49,
		269,
		457
	],
	"./SpireonNew/style": [
		2907,
		21,
		269
	],
	"./SpireonNew/style.js": [
		2907,
		21,
		269
	],
	"./SpireonOld": [
		2146,
		0,
		21,
		49,
		270,
		458
	],
	"./SpireonOld/": [
		2146,
		0,
		21,
		49,
		270,
		458
	],
	"./SpireonOld/index": [
		2146,
		0,
		21,
		49,
		270,
		458
	],
	"./SpireonOld/index.js": [
		2146,
		0,
		21,
		49,
		270,
		458
	],
	"./SpireonOld/style": [
		2908,
		21,
		270
	],
	"./SpireonOld/style.js": [
		2908,
		21,
		270
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 870;
module.exports = webpackAsyncContext;